import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisLineChartResponseDto,
  IAnalysisLineChartResultVo,
} from '../types';

import { pickAxisChartWireVo, pickChartDisplayMeta } from './common';

export function transformLineChartResponseDtoToVo(
  dto: IAnalysisLineChartResponseDto,
): IAnalysisLineChartResultVo {
  const { line_chart: lineChartWire } = dto;
  const { chartData: lineChart, isNoData } = pickAxisChartWireVo(lineChartWire);

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.Line,
    isNoData,
    ...(isNoData ? {} : { lineChart }),
  };
}
